import aboutApp from './icons/aboutApp.svg'
import addIcon from './icons/addIcon.svg'
import addIconCorporate from './icons/addIconCorporate.svg'
import apple14Arrow from './icons/apple14Arrow.svg'
import appleArrow from './icons/appleArrow.svg'
import rightChevron from './icons/rightChevron.svg'
import arLang from './icons/arLang.svg'
import darkBackArrowPages from './icons/darkBackArrowPages.svg'
import lightBackArrowPages from './icons/lightBackArrowPages.svg'
import blueArrow from './icons/blueArrow.svg'
import germanHopRightArrow from './icons/germanHopRightArrow.svg'
import bundle_icon from './icons/bundle_icon.svg'
import callusIcon from './icons/callusIcon.svg'
import Chevron from './icons/Chevron.svg'
import chooseIcon from './icons/chooseIcon.svg'
import connectYourLineCorporateService from './icons/connectYourLineCorporateService.svg'
import corporateAccountIcon from './icons/corporateAccountIcon.svg'
import corporateAdd from './icons/corporateAdd.svg'
import corporateARLanguageIcon from './icons/corporateARLanguageIcon.svg'
import corporateCheck from './icons/corporateCheck.svg'
import corporateDownloadPDF from './icons/corporateDownloadPDF.svg'
import corporateDropDownLangArrow from './icons/corporateDropDownLangArrow.svg'
import corporateEnLanguageIcon from './icons/corporateEnLanguageIcon.svg'
import corporateLogInIcon from './icons/corporateLogInIcon.svg'
import corporateMenu from './icons/corporateMenu.svg'
import corporateMoonDark from './icons/corporateMoonDark.svg'
import corporateNotification from './icons/corporateNotification.svg'
import corporateSunLight from './icons/corporateSunLight.svg'
import darkCorporateDownArrow from './icons/darkCorporateDownArrow.svg'
import lightCorporateDownArrow from './icons/lightCorporateDownArrow.svg'
import lightCorporateRightArrow from './icons/lightCorporateRightArrow.svg'
import darkCorporateRightArrow from './icons/darkCorporateRightArrow.svg'
import corporateAccountNumberIcon from './icons/corporateAccountNumberIcon.svg'
import corporateAccountCodeIcon from './icons/corporateAccountCodeIcon.svg'
import corporateAccountManager from './icons/corporateAccountManager.svg'
import corporateAreaManager from './icons/corporateAreaManager.svg'
import corporateSubscriberClassificationIcon from './icons/corporateSubscriberClassificationIcon.svg'
import corporateTechnicalAdmin from './icons/corporateTechnicalAdmin.svg'
import corporateCustomerNetworkIcon from './icons/corporateCustomerNetworkIcon.svg'
import corporatePayBillsIcon from './icons/corporatePayBillsIcon.svg'
import corporateReconnectIcon from './icons/corporateReconnectIcon.svg'
import corporateServicesIcon from './icons/corporateServicesIcon.svg'
import corporateShieldServiceIcon from './icons/corporateShieldServiceIcon.svg'
import corporateTrackOrderIcon from './icons/corporateTrackOrderIcon.svg'
import corporateTroubleTicketIcon from './icons/corporateTroubleTicketIcon.svg'
import corporateLastBillIcon from './icons/corporateLastBillIcon.svg'
import corporateTotalBalance from './icons/corporateTotalBalance.svg'
import corporateUpArrow from './icons/corporateUpArrow.svg'
import corporateDownArrow from './icons/corporateDownArrow.svg'
import corporateVoiceMessage from './icons/corporateVoiceMessage.svg'
import corporateUploadImage from './icons/corporateUploadImage.svg'
import corporateCheckIcon from './icons/corporateCheckIcon.svg'
import corporateSuccess from './icons/corporateSuccess.svg'
import corporateServiceDirectDebt from './icons/corporateServiceDirectDebt.svg'
import corporateCheckboxIcon from './icons/corporateCheckboxIcon.svg'
import corporateRadioButton from './icons/corporateRadioButton.svg'
import servicesIcon from './icons/servicesIcon.svg'
import corporateSubscriberAddressIcon from './icons/corporateSubscriberAddressIcon.svg'
import corporateSubscriberAccountNumbersIcon from './icons/corporateSubscriberAccountNumbersIcon.svg'
import corporateCalendar from './icons/corporateCalendar.svg'
import corporateFortiNet from './icons/corporateFortiNet.svg'
import corporatePerformanceControl from './icons/corporatePerformanceControl.svg'
import corporateDatePicker from './icons/corporateDatePicker.svg'
import corporateAudioPause from './icons/corporateAudioPause.svg'
import corporateAudioPlay from './icons/corporateAudioPlay.svg'
import corporateRightArrow from './icons/corporateRightArrow.svg'
import emptyRadioButton from './icons/emptyRadioButton.svg'
import corporateFollowMe from './icons/corporateFollowMe.svg'
import corporateCallWaiting from './icons/corporateCallWaiting.svg'
import corporateCallerID from './icons/corporateCallerID.svg'
import corporateSmartServices from './icons/corporateSmartServices.svg'
import corporateBusinessInternet from './icons/corporateBusinessInternet.svg'
import corporateWebHosting from './icons/corporateWebHosting.svg'
import paltelCorporateRequestAdditionalAddresses from './icons/paltelCorporateRequestAdditionalAddresses.svg'
import paltelCorporateAman from './icons/paltelCorporateAman.svg'
import paltelCorporateSpeedChangeIcon from './icons/paltelCorporateSpeedChangeIcon.svg'
import paltelCorporateZerosIcon from './icons/paltelCorporateZerosIcon.svg'
import paltelCorporateSuspendOrderIcon from './icons/paltelCorporateSuspendOrderIcon.svg'
import paltelCorporateInstallationsIcon from './icons/paltelCorporateInstallationsIcon.svg'
import corporateCheckboxServiceIcon from './icons/corporateCheckboxServiceIcon.svg'
import corporateCheckboxUnchecked from './icons/corporateCheckboxUnchecked.svg'
import dark3G from './icons/dark3G.svg'
import darkAddress from './icons/darkAddress.svg'
import darkAlert from './icons/darkAlert.svg'
import darkAppStore from './icons/darkAppStore.svg'
import darkArabicLogo from './icons/darkArabicLogo.svg'
import darkBalance from './icons/darkBalance.svg'
import darkBundles from './icons/darkBundles.svg'
import darkChat from './icons/darkChat.svg'
import darkClassification from './icons/darkClassification.svg'
import darkClose from './icons/darkClose.svg'
import darkDatePickerArrow from './icons/darkDatePickerArrow.svg'
import darkDebit from './icons/darkDebit.svg'
import darkDownArrowBlack from './icons/darkDownArrowBlack.svg'
import email from './icons/email.svg'
import darkEnglishLogo from './icons/darkEnglishLogo.svg'
import darkFilterIcon from './icons/darkFilterIcon.svg'
import darkGooglePlay from './icons/darkGooglePlay.svg'
import darkHistoryFile from './icons/darkHistoryFile.svg'
import darkInternalSearch from './icons/darkInternalSearch.svg'
import darkJawwalPay from './icons/darkJawwalPay.svg'
import darkLeft24Arrow from './icons/darkLeft24Arrow.svg'
import darkLeftArrow from './icons/darkLeftArrow.svg'
import darkLogOut from './icons/darkLogOut.svg'
import  serviceMCN from './icons/serviceMCN.svg'
import darkMenu from './icons/darkMenu.svg'
import darkMenuClose from './icons/darkMenuClose.svg'
import darkMoreIcon from './icons/darkMoreIcon.svg'
import darkMyBills from './icons/darkMyBills.svg'
import darkNoBillsCorporate from './icons/darkNoBillsCorporate.svg'
import darkNoMinBundle from './icons/darkNoMinBundle.svg'
import darkNoNetBundle from './icons/darkNoNetBundle.svg'
import darkNoSMSBundle from './icons/darkNoSMSBundle.svg'
import darkRightArrow from './icons/darkRightArrow.svg'
import darkRoaming from './icons/darkRoaming.svg'
import darkSearchIcon from './icons/darkSearchIcon.svg'
import darkSearchIconMobile from './icons/darkSearchIconMobile.svg'
import darkSelectedNumbers from './icons/darkSelectedNumbers.svg'
import darkServices from './icons/darkServices.svg'
import star from './icons/star.svg'
import darkSwitchNumbers from './icons/darkSwitchNumbers.svg'
import darkTabBundles from './icons/darkTabBundles.svg'
import darkTabHome from './icons/darkTabHome.svg'
import darkTabMore from './icons/darkTabMore.svg'
import darkTabStore from './icons/darkTabStore.svg'
import darkTransferBalance from './icons/darkTransferBalance.svg'
import darkUpArrowGreen from './icons/darkUpArrowGreen.svg'
import darkVisa from './icons/darkVisa.svg'
import darkSwitch from './icons/cardsPaymentIcon.svg'
import serviceSmartMesh from './icons/serviceSmartMesh.svg'
import defaultIcon from './icons/defaultIcon.svg'
import dollarSign from './icons/dollarSign.svg'
import downloadPDF from './icons/downloadPDF.svg'
import emptyStar from './icons/emptyStar.svg'
import enLang from './icons/enLang.svg'
import errorIcon from './icons/errorIcon.svg'
import exchange from './icons/exchange.svg'
import FAQIcon from './icons/FAQIcon.svg'
import filledStar from './icons/filledStar.svg'
import followUpIcon from './icons/followUpIcon.svg'
import featured_icon_lg_warning_Dark from './icons/featured_icon_lg_warning_Dark.svg'
import featured_icon_lg_warning_Light from './icons/featured_icon_lg_warning_Light.svg'
import freeSMSIcon from './icons/freeSMSIcon.svg'
import greenDownArrow from './icons/greenDownArrow.svg'
import handsetInstallments from './icons/handsetInstallments.svg'
import help from './icons/help.svg'
import History from './icons/history.svg'
import info from './icons/info.svg'
import internationalCalling from './icons/internationalCalling.svg'
import internationalRoming from './icons/internationalRoming.svg'
import internetCorporateService from './icons/internetCorporateService.svg'
import internetSettings from './icons/internetSettings.svg'
import jawwalApps from './icons/jawwalApps.svg'
import {
  default as darkJawwalCard,
  // eslint-disable-next-line prettier/prettier
  default as lightJawwalCard,
} from './icons/JawwalCard.svg'
import light3G from './icons/light3G.svg'
import lightAddress from './icons/lightAddress.svg'
import lightAlert from './icons/lightAlert.svg'
import lightAppStore from './icons/lightAppStore.svg'
import lightArabicLogo from './icons/lightArabicLogo.svg'
import lightBalance from './icons/lightBalance.svg'
import lightBundles from './icons/lightBundles.svg'
import editIcon from './icons/editIcon.svg'
import edit05 from './icons/edit-05.svg'
import {
  default as chatIcon,
  // eslint-disable-next-line prettier/prettier
  default as lightChat,
} from './icons/lightChat.svg'
import {
  // eslint-disable-next-line prettier/prettier
  default as videoChat,
} from './icons/chatVideo.svg'
import lightCheck from './icons/lightCheck.svg'
import lightClassification from './icons/lightClassification.svg'
import lightClose from './icons/lightClose.svg'
import lightDatePickerArrow from './icons/lightDatePickerArrow.svg'
import debit from './icons/debit.svg'
import lightDownArrowBlack from './icons/lightDownArrowBlack.svg'
import downArrow from './icons/downArrow.svg'
import lightDownArrowGreen from './icons/lightDownArrowGreen.svg'
import lightEnglishLogo from './icons/lightEnglishLogo.svg'
import lightFilterIcon from './icons/lightFilterIcon.svg'
import lightGooglePlay from './icons/lightGooglePlay.svg'
import lightHistoryFile from './icons/lightHistoryFile.svg'
import lightInternalSearch from './icons/lightInternalSearch.svg'
import lightJawwalPay from './icons/lightJawwalPay.svg'
import lightLeft24Arrow from './icons/lightLeft24Arrow.svg'
import lightLeftArrow from './icons/lightLeftArrow.svg'
import lightLogOut from './icons/lightLogOut.svg'
import lightMenu from './icons/lightMenu.svg'
import lightMenuClose from './icons/lightMenuClose.svg'
import min from './icons/min.svg'
import lightMoreIcon from './icons/lightMoreIcon.svg'
import lightMyBills from './icons/lightMyBills.svg'
import lightNoBillsCorporate from './icons/lightNoBillsCorporate.svg'
import lightNoMinBundle from './icons/lightNoMinBundle.svg'
import lightNoNetBundle from './icons/lightNoNetBundle.svg'
import lightNoSMSBundle from './icons/lightNoSMSBundle.svg'
import notification from './icons/notification.svg'
import lightOfferCard from './icons/lightOfferCard.svg'
import others from './icons/others.svg'
import lightRightArrow from './icons/lightRightArrow.svg'
import lightRoaming from './icons/lightRoaming.svg'
import lightSearchIcon from './icons/lightSearchIcon.svg'
import lightSearchIconMobile from './icons/lightSearchIconMobile.svg'
import lightSelectedNumbers from './icons/lightSelectedNumbers.svg'
import lightServices from './icons/lightServices.svg'
import sms from './icons/sms.svg'
import lightSwitchNumbers from './icons/lightSwitchNumbers.svg'
import lightTabBundles from './icons/lightTabBundles.svg'
import tabBundlesActive from './icons/lightTabBundlesActive.svg'
import lightTabHome from './icons/lightTabHome.svg'
import tabHomeActive from './icons/lightTabHomeActive.svg'
import lightTabMore from './icons/lightTabMore.svg'
import lightTabStore from './icons/lightTabStore.svg'
import tabStoreActive from './icons/lightTabStoreActive.svg'
import lightTransferBalance from './icons/lightTransferBalance.svg'
import {
  // eslint-disable-next-line prettier/prettier
  default as serviceBalanceTransfer,
} from './icons/lightTransferBalance.svg'
import lightUpArrowGreen from './icons/lightUpArrowGreen.svg'
import lightVisa from './icons/lightVisa.svg'
import lightSwitch from './icons/cardsPaymentIcon.svg'
import logo from './icons/Logo.svg'
import mainARLanguageIcon from './icons/mainARLanguageIcon.svg'
import mainDropDownLangArrow from './icons/mainDropDownLangArrow.svg'
import mainEnLanguageIcon from './icons/mainEnLanguageIcon.svg'
import minCorporateService from './icons/minCorporateService.svg'
import {
  default as darkMixRefill,
  // eslint-disable-next-line prettier/prettier
  default as lightMixRefill,
} from './icons/MixRefill.svg'
import mobileCorporateIcon from './icons/mobileCorporateIcon.svg'
import moonDark from './icons/moonDark.svg'
import moonLight from './icons/moonLight.svg'
import darkMoon from './icons/darkMoon.svg'
import lightMoon from './icons/lightMoon.svg'
import noBills from './icons/noBills.svg'
import noSIMOffer from './icons/noSIMOffer.svg'
import notificationCorporateService from './icons/notificationCorporateService.svg'
import packageBackGround from './icons/packageBackGround.svg'
import packageDetailsBundles from './icons/packageDetailsBundles.svg'
import payBillsIcon from './icons/payBillsIcon.svg'
import phone from './icons/phone.svg'
import plans from './icons/plans.svg'
import {
  default as darkPUKIcon,
  // eslint-disable-next-line prettier/prettier
  default as lightPUKIcon,
} from './icons/PUKIcon.svg'
import purpleArrow from './icons/purpleArrow.svg'
import quickAccess from './icons/quickAccess.svg'
import ratingIcon from './icons/ratingIcon.svg'
import reconnectionCorporateService from './icons/reconnectionCorporateService.svg'
import roamingCorporateService from './icons/roamingCorporateService.svg'
import search from './icons/search.svg'
import searchSmallIcon from './icons/searchSmallIcon.svg'
import international_Youth_Dark from './icons/International_Youth_Dark.svg'
import international_Youth_Light from './icons/International_Youth_Light.svg'
import international_Mass_Dark from './icons/International_Mass_Dark.svg'
import international_Mass_Light from './icons/International_Mass_Light.svg'
import youthMicroLoans from './icons/youthMicroLoans.svg'
import serviceInternationalRoaming from './icons/serviceInternationalRoaming.svg'
import serviceInternet from './icons/serviceInternet.svg'
import serviceLocalRoaming from './icons/serviceLocalRoaming.svg'
import serviceMinute from './icons/serviceMinute.svg'
import serviceMMS from './icons/serviceMMS.svg'
import servicePackageMigration from './icons/servicePackageMigration.svg'
import serviceRecharge from './icons/serviceRecharge.svg'
import serviceReconnect from './icons/serviceReconnect.svg'
import serviceRoamingIcon from './icons/serviceRoamingIcon.svg'
import serviceSMS from './icons/serviceSMS.svg'
import serviceVAS from './icons/serviceVAS.svg'
import serviceYourBalance from './icons/serviceYourBalance.svg'
import serviceCallMeBack from './icons/serviceCallMeBack.svg'
import serviceBalanceHistory from './icons/serviceBalanceHistory.svg'
import serviceSendGift from './icons/serviceSendGift.svg'
import serviceSimSwap from './icons/serviceSimSwap.svg'
import serviceSubscriptionRequest from './icons/serviceSubscriptionRequest.svg'
import serviceFixedLineVAS from './icons/fixedLineVas.svg'
import serviceZeros from './icons/serviceZeros.svg'
import serviceCalls from './icons/serviceCalls.svg'
import serviceMadded from './icons/serviceMadded.svg'
import Roaming_Mass_Dark from './icons/Roaming_Mass_Dark.svg'
import Romaing_Mass_Light from './icons/Romaing_Mass_Light.svg'
import Roaming_Youth_Light from './icons/Roaming_Youth_Light.svg'
import Roaming_Youth_Dark from './icons/Roaming_Youth_Dark.svg'
import serviceSelectedNumbers from './icons/serviceSelectedNumbers.svg'
import serviceSelectYourNumber from './icons/serviceSelectYourNumber.svg'
import settings from './icons/settings.svg'
import share from './icons/share.svg'
import showroomsIcon from './icons/showroomsIcon.svg'
import SIMOffer from './icons/SIMOffer.svg'
import smsCorporateService from './icons/smsCorporateService.svg'
import appleBundlesCorporateService from './icons/appleBundlesCorporateService.svg'
import success from './icons/success.svg'
import sunDark from './icons/sunDark.svg'
import sunLight from './icons/sunLight.svg'
import darkSun from './icons/darkSun.svg'
import lightSun from './icons/lightSun.svg'
import supportAndHelp from './icons/supportAndHelp.svg'
import swimSwapCorporateService from './icons/swimSwapCorporateService.svg'
import tabMoreActive from './icons/tabMoreActive.svg'
import telegramIcon from './icons/telegramIcon.svg'
import TermsAndCondition from './icons/TermsAndCondition.svg'
import searchClose from './icons/searchClose.svg'
import test from './icons/test.svg'
import tipsIcon from './icons/tipsIcon.svg'
import totalBills from './icons/totalBills.svg'
import unchecked from './icons/unchecked.svg'
import usage from './icons/usage.svg'
import vasCorporateService from './icons/vasCorporateService.svg'
import whatsAppIcon from './icons/whatsAppIcon.svg'
import hotOffers from './icons/hotOffers.svg'
import combo from './icons/combo.svg'
import calls from './icons/calls.svg'
import privatetopupcode from './icons/privatetopupcode.svg'
import youthprivatetopupcode from './icons/youthprivatetopupcode.svg'
import youthServiceMadded from './icons/youthServiceMadded.svg'
import ramdanOfferIcon from './icons/ramdanOfferIcon.png'
import balanceIcon from './icons/balanceIcon.svg'
import VisaCard from './icons/VisaCard.svg'
import masterCard from './icons/masterCard.svg'
import hisabiLogo from './icons/hisabiLogo.svg'
import quickAccessTag from './icons/quickAccessTag.svg'
import lang from './icons/lang.svg'
import authorizedNumber from './icons/authorizedNumber.svg'
import logout from './icons/logout.svg'
import whiteArrow from './icons/whiteArrow.svg'
import deviceInstallments from './icons/deviceInstallments.svg'
import blueChevron from './icons/blueChevron.svg'
import chevronGrey from './icons/chevron-grey.svg'
import chevronBlue from './icons/chevron-blue.svg'
import chevronGreen from './icons/chevron-green.svg'
import activeService from './icons/activeService.svg'
import emptySearch from './icons/emptySearch.svg'
import internationalMinutes from './icons/internationalMinutes.svg'
import mobileMinutes from './icons/mobileMinutes.svg'
import localMinutes from './icons/localMinutes.svg'
import greenRadioButton from './icons/greenRadioButton.svg'
import noActvieServices from './icons/noActiveServices.svg'
import voiceMessage from './icons/voiceMessage.svg'
import cancel from './icons/Canceled.svg'
import inProgress from './icons/InProgress.svg'
import checkCircle from './icons/check-circle.svg'
import datePicker from './icons/datePicker.svg'
import uploadFile from './icons/uploadFile.svg'
import radio_Youth from './icons/radio_Youth.svg'
import smsIcon from './icons/smsIcon.svg'
import submittedIcon from './icons/submittedIcon.svg'
import inProgressIcon from './icons/inProgressIcon.svg'
import completedIcon from './icons/completedIcon.svg'
import uploadImage from './icons/uploadImage.svg'
import uploadVideo from './icons/uploadVideo.svg'
import removeFile from './icons/removeFile.svg'
import currentLocation from './icons/currentLocation.svg'
import technicalLocation from './icons/technicalLocation.svg'
import backToMainArrow from './icons/backToMainArrow.svg'
import currentLocationMarker from './icons/currentLocationMarker.svg'
import audioPlay from './icons/audioPlay.svg'
import audioPause from './icons/audioPause.svg'
import recordIcon from './icons/recordIcon.svg'
import chevron_Down_Youth from './icons/chevron_Down_Youth.svg'
import chevron_Up_Youth from './icons/chevron_Up_Youth.svg'
import paltel from './icons/paltel.svg'
import jawwal from './icons/jawwal.svg'
import corporateSearch from './icons/corporateSearch.svg'
import corporateFilterIcon from './icons/corporateFilterIcon.svg'
import lightEmptyCheckBox from './icons/lightEmptyCheckBox.svg'
import microLoans from './icons/microLoans.svg'
import paltelNewSubscriptionRequest from './icons/paltelNewSubscriptionRequest.svg'
import lastBillIcon from './icons/lastBillIcon.svg'
import paltelSmartMesh from './icons/paltelSmartMesh.svg'
import paltelSpeedUpgrade from './icons/paltelSpeedUpgrade.svg'
import paltelFixedIP from './icons/paltelFixedIP.svg'
import paltelVAS from './icons/paltelVAS.svg'
import paltelPoints from './icons/paltelPoints.svg'
import troubleTicket from './icons/paltelTroubleTicket.svg'
import paltelTrackOrder from './icons/paltelTrackOrder.svg'
import paltelAmanService from './icons/paltelAmanService.svg'
import lightQuickAccessUsage from './icons/lightQuickAccessUsage.svg'
import paltelFixedLineServices from './icons/paltelFixedLineServices.svg'
import lightRecurringPayment from './icons/lightRecurringPayment.svg'

import darkLastBillIcon from './icons/darkLastBillIcon.svg'
import darkQuickAccessUsage from './icons/darkQuickAccessUsage.svg'
import darkRecurringPayment from './icons/darkRecurringPayment.svg'
import youthActiveService from './icons/youthActiveService.svg'
import creditCardAddIcon from './icons/creditCardAddIcon.svg'
import recurringPaymentIcon from './icons/recurringPaymentIcon.svg'
import cardsManagement from './icons/cardsManagement.svg'
import numberManagement from './icons/numberManagement.svg'
import youthCardsManagement from './icons/youthCardsManagement.svg'
import whiteDownloadPDF from './icons/whiteDownloadPDF.svg'
import darkEmptyCheckBox from './icons/darkEmptyCheckBox.svg'
import ramadanOffersIcon from './icons/ramadanOffersIcon.svg'
import gazaRamadanOffersIcon from './icons/gazaRamadanOffersIcon.svg'
import ramadanGiftIcon from './icons/ramadanGiftIcon.svg'
import ramadanCampaignIcon from './icons/ramadanCampaignIcon.svg'
import esimQRIcon from './icons/esimQRIcon.svg'
import serviceBaringCalls from './icons/serviceBaringCalls.svg'
import paltelLocalIcon from './icons/paltelLocalIcon.svg'
import corporateActiveServicesIcon from './icons/corporateActiveServicesIcon.svg'
import corporateDeviceInstallments from './icons/corporateDeviceInstallments.svg'
import alert from './icons/alert.svg'
import goodMorningIcon from './icons/goodMorningIcon.svg'
import goodAfternoonIcon from './icons/goodAfternoonIcon.svg'
import goodEveningIcon from './icons/goodEveningIcon.svg'
import corporateDevice from './icons/corporateDevice.svg'
import youthCheckbox from './icons/youthCheckbox.svg'
import massCheckbox from './icons/massCheckbox.svg'
import irCorporateService from './icons/irCorporateService.svg'
import lightWifiSettingsIcon from './icons/lightWifiSettingsIcon.svg'
import wifiSettingsEmptyStatus from './icons/wifiSettingsEmptyStatus.svg'
import deviceManegemntIcon from './icons/deviceManegemntIcon.svg'
import networkSettingsIcon from './icons/networkSettingsIcon.svg'
import activateNewNetworkIcon from './icons/activateNewNetworkIcon.svg'
import wifiSettingsEditIcon from './icons/wifiSettingsEditIcon.svg'
import eyeOnPasswordIcon from './icons/eyeOnPasswordIcon.svg'
import eyeOffPasswordIcon from './icons/eyeOffPassowrdIcon.svg'
import wifiSettingsEmpyStatusIcon from './icons/wifiSettingsEmpyStatusIcon.svg'
import warrantyIcon from './icons/warrantyIcon.png'
import corporateInfoIcon from './icons/corporateInfoIcon.svg'
import moreSettingsIcon from './icons/moreSettingsIcon.svg'
import deviceManagement from './icons/deviceManagement.svg'
import QuickAccessUsage from './icons/QuickAccessUsage.svg'
import directDebit from './icons/directDebit.svg'
import serviceInternational from './icons/serviceInternational.svg'
import greenUpArrow from './icons/greenUpArrow.svg'
import upArrow from './icons/upArrow.svg'
import devices from './icons/devices.svg'
import eStore from './icons/eStore.svg'
import blackArrow from './icons/blackArrow.svg'
import corporateSettings from './icons/corporateSettings.svg'
import serviceDirectDebt from './icons/serviceDirectDebt.svg'
import greenArrow from './icons/greenArrow.svg'
import corporateUploadFile from './icons/corporateUploadFile.svg'
import corporateCloseCircleIcon from './icons/corporateCloseCircleIcon.svg'
import smsBulk from './icons/smsBulk.svg'
import messangerIcon from './icons/messangerIcon.svg'
import leftGreenArrow from './icons/leftGreenArrow.svg'
import wireIcon from './icons/wireIcon.svg'
import buyForAnotherNumber from './icons/buyForAnotherNumber.svg'
import darkEmptyRadioButton from './icons/darkEmptyRadioButton.svg'
import lightEmptyRadioButton from './icons/lightEmptyRadioButton.svg'
import gift from './icons/gift.svg'
import warningBlueIcon from './icons/warningBlueIcon.svg'
import installationsEmptyIcon from './icons/installations_empty_icon.svg'
import uploadGreenIcon from './icons/uploadGreenIcon.svg'
import downloadWhiteIcon from './icons/downloadWhiteIcon.svg'
import addAddressIcon from './icons/addAddressIcon.svg'
import greenCheckBox from './icons/greenCheckBox.svg'
import reflectIcon from './icons/reflectIcon.svg'
import roamingCheckIcon from './icons/roamingCheckIcon.svg'
import roamingPlusIcon from './icons/roamingAddIcon.svg'
import roamingRemoveIcon from './icons/roamingDeleteIcon.svg'
import payBillsForOthersIcon from './icons/payBillsForOthersIcon.svg'
import lightUserIcon from './icons/lightUserIcon.svg'
import darkUserIcon from './icons/darkUserIcon.svg'
import creditCardIcon from './icons/creditCardIcon.svg'
import emptyCheckBox from './icons/emptyCheckBox.svg'
import sadadIcon from './icons/sadadIcon.svg'
import coinsStacked01 from './icons/coins-stacked-01.svg'
import frame19873 from './icons/frame-19873.svg'
import buttonsButton from './icons/buttons-button-true-secondary-tint-xs-default-true-false-false.svg'
import switchVertical01 from './icons/switch-vertical-01.svg'
import switchVertical02 from './icons/switch-vertical-02.svg'
import switchVertical03 from './icons/switch-vertical-03.svg'
import switchNumbersLight from './icons/SwitchNumbersLight.svg'
import switchNumbersDark from './icons/switchNumbersDark.svg'
import returnToMainNumberLight from './icons/ReturnToMainNumberLight.svg'
import returnToMainNumberDark from './icons/ReturnToMainNumberDark.svg'
const ICONS = {
  greenArrow,
  devices,
  eStore,
  upArrow,
  greenUpArrow,
  greenDownArrow,
  darkEmptyCheckBox,
  youthCardsManagement,
  cardsManagement,
  numberManagement,
  lightEmptyCheckBox,
  greenCheckBox,
  corporateFilterIcon,
  corporateSearch,
  youthActiveService,
  jawwal,
  paltel,
  smsIcon,
  radio_Youth,
  chevron_Up_Youth,
  chevron_Down_Youth,
  recordIcon,
  audioPause,
  audioPlay,
  currentLocationMarker,
  backToMainArrow,
  technicalLocation,
  currentLocation,
  removeFile,
  uploadImage,
  uploadVideo,
  submittedIcon,
  inProgressIcon,
  completedIcon,
  uploadFile,
  datePicker,
  voiceMessage,
  noActvieServices,
  internationalMinutes,
  mobileMinutes,
  localMinutes,
  activeService,
  blueChevron,
  deviceInstallments,
  whiteArrow,
  privatetopupcode,
  apple14Arrow,
  lightCheck,
  darkClassification,
  email,
  darkAddress,
  darkDebit,
  lightSwitchNumbers,
  darkSwitchNumbers,
  lightAddress,
  lightClassification,
  unchecked,
  debit,
  History,
  darkHistoryFile,
  darkMyBills,
  usage,
  downloadPDF,
  handsetInstallments,
  appleArrow,
  rightChevron,
  success,
  packageDetailsBundles,
  packageBackGround,
  arLang,
  blueArrow,
  germanHopRightArrow,
  bundle_icon,
  darkChat,
  Chevron,
  chooseIcon,
  dark3G,
  darkAlert,
  darkLeft24Arrow,
  darkArabicLogo,
  darkBalance,
  darkBundles,
  darkClose,
  darkDownArrowBlack,
  darkEnglishLogo,
  darkLeftArrow,
  darkLogOut,
  darkMenu,
  darkMenuClose,
  darkMoreIcon,
  quickAccess,
  darkRightArrow,
  darkRoaming,
  darkSearchIcon,
  darkSearchIconMobile,
  darkSelectedNumbers,
  darkServices,
  darkTabBundles,
  darkTabHome,
  darkTabMore,
  darkTabStore,
  darkTransferBalance,
  darkUpArrowGreen,
  darkLastBillIcon,
  paltelSmartMesh,
  paltelNewSubscriptionRequest,
  darkQuickAccessUsage,
  paltelFixedLineServices,
  darkRecurringPayment,
  darkCorporateDownArrow,
  darkCorporateRightArrow,
  darkBackArrowPages,
  dollarSign,
  enLang,
  help,
  internationalCalling,
  internationalRoming,
  info,
  light3G,
  lightAlert,
  lightLeft24Arrow,
  lightArabicLogo,
  lightBalance,
  lightBackArrowPages,
  lightBundles,
  lightClose,
  lightDownArrowBlack,
  lightDownArrowGreen,
  lightEnglishLogo,
  exchange,
  lightLeftArrow,
  lightLogOut,
  lightMenu,
  lightMenuClose,
  min,
  lightMoreIcon,
  notification,
  lightOfferCard,
  others,
  lightRightArrow,
  lightRoaming,
  lightSearchIcon,
  lightSearchIconMobile,
  lightSelectedNumbers,
  lightServices,
  sms,
  star,
  lightTabBundles,
  tabBundlesActive,
  lightTabHome,
  tabHomeActive,
  lightTabMore,
  tabMoreActive,
  lightTabStore,
  tabStoreActive,
  lightTransferBalance,
  lightUpArrowGreen,
  downArrow,
  lightChat,
  videoChat,
  lightMyBills,
  lightHistoryFile,
  greenRadioButton,
  paltelVAS,
  paltelFixedIP,
  paltelSpeedUpgrade,
  troubleTicket,
  paltelPoints,
  paltelTrackOrder,
  paltelAmanService,
  lightQuickAccessUsage,
  lightRecurringPayment,
  lightCorporateDownArrow,
  lightCorporateRightArrow,
  logo,
  moonDark,
  moonLight,
  lightMoon,
  darkMoon,
  noBills,
  phone,
  plans,
  purpleArrow,
  sunDark,
  darkSun,
  sunLight,
  lightSun,
  test,
  totalBills,
  darkJawwalPay,
  darkVisa,
  darkSwitch,
  lightDatePickerArrow,
  darkDatePickerArrow,
  lightJawwalPay,
  lightVisa,
  lightSwitch,
  darkAppStore,
  lightAppStore,
  darkGooglePlay,
  lightGooglePlay,
  lightInternalSearch,
  darkInternalSearch,
  errorIcon,
  lightNoNetBundle,
  lightNoSMSBundle,
  lightNoMinBundle,
  darkNoNetBundle,
  darkNoSMSBundle,
  darkNoMinBundle,
  defaultIcon,
  editIcon,
  edit05,
  serviceInternet,
  international_Youth_Dark,
  international_Youth_Light,
  international_Mass_Dark,
  international_Mass_Light,
  youthMicroLoans,
  Roaming_Mass_Dark,
  Romaing_Mass_Light,
  Roaming_Youth_Dark,
  Roaming_Youth_Light,
  serviceRoamingIcon,
  serviceMinute,
  serviceSMS,
  payBillsIcon,
  serviceRecharge,
  serviceBalanceTransfer,
  servicePackageMigration,
  serviceVAS,
  serviceMCN,
  serviceSelectedNumbers,
  serviceSelectYourNumber,
  serviceInternationalRoaming,
  serviceLocalRoaming,
  serviceYourBalance,
  serviceReconnect,
  serviceMMS,
  serviceCallMeBack,
  serviceBalanceHistory,
  serviceSendGift,
  serviceSimSwap,
  serviceSmartMesh,
  serviceFixedLineVAS,
  serviceSubscriptionRequest,
  serviceCalls,
  serviceMadded,
  serviceDirectDebt,
  supportAndHelp,
  settings,
  jawwalApps,
  TermsAndCondition,
  share,
  aboutApp,
  tipsIcon,
  FAQIcon,
  ratingIcon,
  showroomsIcon,
  callusIcon,
  followUpIcon,
  chatIcon,
  SIMOffer,
  noSIMOffer,
  addIcon,
  servicesIcon,
  corporateSubscriberAddressIcon,
  corporateSubscriberAccountNumbersIcon,
  corporateCalendar,
  corporateFortiNet,
  corporatePerformanceControl,
  corporateDatePicker,
  corporateAudioPause,
  corporateAudioPlay,
  corporateFollowMe,
  corporateCallWaiting,
  corporateCallerID,
  corporateSmartServices,
  corporateBusinessInternet,
  corporateWebHosting,
  paltelCorporateRequestAdditionalAddresses,
  paltelCorporateAman,
  paltelCorporateSpeedChangeIcon,
  paltelCorporateZerosIcon,
  corporateCheckboxServiceIcon,
  corporateCheckboxUnchecked,
  paltelCorporateSuspendOrderIcon,
  paltelCorporateInstallationsIcon,
  whatsAppIcon,
  telegramIcon,
  filledStar,
  emptyStar,
  lightPUKIcon,
  darkPUKIcon,
  freeSMSIcon,
  mainEnLanguageIcon,
  mainARLanguageIcon,
  mainDropDownLangArrow,
  darkMixRefill,
  lightMixRefill,
  darkJawwalCard,
  lightJawwalCard,
  internetSettings,
  corporateLogInIcon,
  corporateNotification,
  corporateEnLanguageIcon,
  corporateARLanguageIcon,
  corporateDropDownLangArrow,
  corporateSunLight,
  corporateMoonDark,
  corporateMenu,
  corporateCheck,
  corporateAccountNumberIcon,
  corporateAccountCodeIcon,
  corporateAccountManager,
  corporateAreaManager,
  corporateSubscriberClassificationIcon,
  corporateTechnicalAdmin,
  corporateCustomerNetworkIcon,
  corporateShieldServiceIcon,
  corporateTrackOrderIcon,
  corporateTroubleTicketIcon,
  corporatePayBillsIcon,
  corporateReconnectIcon,
  corporateServicesIcon,
  corporateLastBillIcon,
  corporateTotalBalance,
  corporateUpArrow,
  corporateDownArrow,
  corporateVoiceMessage,
  corporateSuccess,
  corporateServiceDirectDebt,
  lightFilterIcon,
  darkFilterIcon,
  corporateAccountIcon,
  corporateAdd,
  corporateUploadImage,
  corporateCheckIcon,
  corporateCheckboxIcon,
  corporateRadioButton,
  corporateActiveServicesIcon,
  corporateDeviceInstallments,
  mobileCorporateIcon,
  internetCorporateService,
  minCorporateService,
  smsCorporateService,
  roamingCorporateService,
  vasCorporateService,
  swimSwapCorporateService,
  notificationCorporateService,
  reconnectionCorporateService,
  connectYourLineCorporateService,
  search,
  searchSmallIcon,
  searchClose,
  addIconCorporate,
  corporateDownloadPDF,
  lightNoBillsCorporate,
  darkNoBillsCorporate,
  hotOffers,
  combo,
  calls,
  youthprivatetopupcode,
  youthServiceMadded,
  ramdanOfferIcon,
  balanceIcon,
  VisaCard,
  masterCard,
  hisabiLogo,
  lang,
  quickAccessTag,
  authorizedNumber,
  logout,
  serviceZeros,
  lastBillIcon,
  emptySearch,
  cancel,
  inProgress,
  checkCircle,
  whiteDownloadPDF,
  creditCardAddIcon,
  recurringPaymentIcon,
  microLoans,
  appleBundlesCorporateService,
  corporateRightArrow,
  emptyRadioButton,
  ramadanOffersIcon,
  gazaRamadanOffersIcon,
  ramadanGiftIcon,
  ramadanCampaignIcon,
  esimQRIcon,
  serviceBaringCalls,
  paltelLocalIcon,
  alert,
  goodMorningIcon,
  goodAfternoonIcon,
  goodEveningIcon,
  corporateDevice,
  youthCheckbox,
  massCheckbox,
  irCorporateService,
  warrantyIcon,
  corporateInfoIcon,
  moreSettingsIcon,
  deviceManagement,
  QuickAccessUsage,
  directDebit,
  serviceInternational,
  blackArrow,
  corporateSettings,
  lightWifiSettingsIcon,
  wifiSettingsEmptyStatus,
  deviceManegemntIcon,
  networkSettingsIcon,
  activateNewNetworkIcon,
  wifiSettingsEditIcon,
  eyeOnPasswordIcon,
  eyeOffPasswordIcon,
  wifiSettingsEmpyStatusIcon,
  corporateUploadFile,
  corporateCloseCircleIcon,
  smsBulk,
  messangerIcon,
  leftGreenArrow,
  wireIcon,
  buyForAnotherNumber,
  darkEmptyRadioButton,
  lightEmptyRadioButton,
  gift,
  warningBlueIcon,
  featured_icon_lg_warning_Dark,
  featured_icon_lg_warning_Light,
  installationsEmptyIcon,
  uploadGreenIcon,
  downloadWhiteIcon,
  addAddressIcon,
  reflectIcon,
  roamingCheckIcon,
  roamingPlusIcon,
  roamingRemoveIcon,
  payBillsForOthersIcon,
  lightUserIcon,
  darkUserIcon,
  creditCardIcon,
  emptyCheckBox,
  sadadIcon,
  coinsStacked01,
  frame19873,
  buttonsButton,
  switchVertical01,
  switchVertical02,
  switchVertical03,
  chevronGrey,
  chevronBlue,
  chevronGreen,
  switchNumbersLight,
  switchNumbersDark,
  returnToMainNumberLight,
  returnToMainNumberDark
}
export default ICONS
